import { ElMessage } from 'element-plus'
import Constant from './constant'

export function goToPage(path, replace = false) {
  // 动态导入router避免循环依赖
  import('../router').then(routerModule => {
    const router = routerModule.default
    if (replace) {
      router.replace(path)
    } else {
      router.push(path)
    }
  })
}

export function isNotNull(value) {
  return value !== null && value !== undefined
}

export function showDanger(message) {
  ElMessage.error(message)
}

export function showWarning(message) {
  ElMessage.warning(message)
} 